import { ModifyPredictionCommand } from "./Base/ModifyPredictionCommand";
import { CanExecuteResponse } from "./Base/CanExecuteResponse";
import { PredictionTypeEnum } from "../../../Enums/PredictionTypeEnum";
import { EventPredictions } from "../../StagePrediction/EventPredictions/EventPredictions";
import { LeaderboardPrediction } from "../../StagePrediction/LeaderboardPredictions/LeaderboardPrediction";
import { ICompetitionPrediction } from "../Interfaces/ICompetitionPrediction";

export class MoveAthleteCommand<T extends ICompetitionPrediction> extends ModifyPredictionCommand<T> {

	private readonly _indexFrom: number;
	private readonly _indexTo: number;

	constructor(wsm: T, indexFrom: number, indexTo: number, stageId: string, promptConfirmed: boolean, strongmanEventId?: number) {
		super(wsm, stageId, promptConfirmed, strongmanEventId);

		this._indexFrom = indexFrom;
		this._indexTo = indexTo;
	}

	public override CanExecute(): CanExecuteResponse {
		return new CanExecuteResponse(true);
	}

	public override Execute(): boolean {
		const predictionForStage = this.CompetitionPrediction.GetPredictionFor(this.Stage.Id);

		if(predictionForStage.PredictionType === PredictionTypeEnum.Events) {
			if(!this.StrongmanEventId) {
				throw new Error("StrongmanEventId must be supplied for Events prediction type");
			}

			return (predictionForStage as EventPredictions).MoveAthlete(this._indexFrom, this._indexTo, this.StrongmanEventId);
		} else {
			if(this.StrongmanEventId) {
				throw new Error("StrongmanEventId was supplied but isn't applicable for Leaderboard predictions");
			}

			return (predictionForStage as LeaderboardPrediction).MoveAthlete(this._indexFrom, this._indexTo);
		}
	}
}

